import { Component } from 'react';

import CustomLinkButton from "GeneralComponents/CustomLinkButton";
import LimitedContent from "GeneralComponents/LimitedContent";
import CarouselItem from "../Carousel.interface";
import ComponentImage from 'GeneralComponents/ComponentImage';
import { MediaItem } from 'Interfaces/general.interface';

import "./Icons.css";



export default class IconsCarouselItem extends Component {

    props: any;

    state: CarouselItem;



    constructor(props) {
        super(props);

        this.state = {
            index: this.props.carouselItem.index,
            title: this.props.carouselItem.title,
            richDescription: this.props.carouselItem.richDescription,
            content: this.props.carouselItem.content,
            url: this.props.carouselItem.url,
            link: this.props.carouselItem.link,
            icon: this.props.carouselItem.icon,
            image: this.props.carouselItem.image as MediaItem,
            mobileImage: this.props.carouselItem.mobileImage as MediaItem,
            createDate:null
        };
    }

    render() {

        const iconsHasImages = this.props.getIconsHasImages();
        const iconClass = (this.state.icon) + ' minisite-font-36 pallete-color d-flex align-items-center justify-content-center';


       
        return (



            <div className="item mst-carousel-item " >


                <div className="mst-card p-4 p-md-5 p-lg-5" >

                    <div className="overflow-hidden mb-2">
                        <div className="mb-3 mb-lg-4 icon-bg-color">

                            {
                                iconsHasImages ?

                                    this.state.image.url &&

                                        <ComponentImage
                                            image={this.state.image}
                                            imageClass="mx-auto"
                                            mobileImage={this.state.mobileImage}
                                            mobileImageClass=""
                                            wrapperDivClass="img-wrapper" />

                                :

                                    < i className={iconClass}></i>
                            }
                            
                        </div>
                       


                        <div className="mst-card-content content-txt">

                            <h3 className="h3 mb-1">{this.state.title}</h3>
                           
                            <LimitedContent htmlContent={this.state.richDescription} classNames="gray-txt mst-date-txt"></LimitedContent>
                            

                            <div className="mx-1 hr mb-4 mt-2"></div>



                            <LimitedContent htmlContent={this.state.content} classNames="gray-txt mb-4 mst-item-short-desc"></LimitedContent>


                            
                            


                        </div>

                       
                    </div>
                    <div className="align-bottom " >

                        <CustomLinkButton
                            title={this.state.title}
                            pageUrl={this.state.url}
                            link={this.state.link}
                            isBtn={true}
                            btnClass={"btn btn-outline-primary mst-btn"}
                            linkClass={""}
                            dir={this.props.dir}
                            linkIcon={true}/>

                    </div>
                </div>
            </div>




        );
    }
}
